import React, { useContext, useMemo } from "react";
import { Link, useLocation, useParams } from "react-router-dom";

import "./BreadCrumb.css";
import { ReactComponent as ChevronUp } from "../../assets/icons/chevron-up.svg";
import { getServiceLink } from "../../utilities/misc";
import { CategoryContext, LocaleContext } from "../../AppProvider";
import { formatCategoryName } from "../../App";

const BreadCrumb = () => {
  const { locale } = useContext(LocaleContext);
  const { serviceName } = useParams();

  const [categories] = useContext(CategoryContext);

  const { pathname } = useLocation();

  const service_link = getServiceLink(locale);

  const breadcrumbs = useMemo(() => {
    if (serviceName) {
      return [
        { name: "Services", link: `/${service_link}` },
        {
          name:
            categories.find((category, n) => {
              return formatCategoryName(category) === serviceName;
            })?.name ??
            serviceName
              .split("-")
              .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
              .join(" "),
          link: `/${service_link}/${serviceName}`
        }
      ];
    } else if (pathname.startsWith(`/${service_link}/cleaning-products`)) {
      return [
        { name: "Services", link: `/${service_link}` },
        {
          name: "Cleaning Products",
          link: `/${service_link}/cleaning-products`
        }
      ];
    } else if (pathname.startsWith("/cart")) {
      return [{ name: "Cart", link: "/cart" }];
    } else if (pathname.startsWith(`/${service_link}`)) {
      return [{ name: "Services", link: `/${service_link}` }];
    } else return [];
  }, [categories, pathname, serviceName, service_link]);

  return (
    <div className="breadcrumb_wrapper">
      <div className="header_icon"></div>
      <div className="breadcrumb_container">
        <a href="http://cleanbee.ie">Home</a>
        {breadcrumbs.length > 0 && <ChevronUp />}
        {breadcrumbs.map((crumb, index) => (
          <React.Fragment key={index}>
            <Link to={crumb.link}>{crumb.name}</Link>
            {index < breadcrumbs.length - 1 && <ChevronUp />}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default BreadCrumb;
